import React from 'react'

class SellAllButton extends React.Component {

    render() {
        return <button class="btn btn-success" onClick={() => this.props.sellAllShares(this.props.stock)}>Sell All</button>;
    }
}

export default SellAllButton